import React, { useState, useEffect } from 'react'

import {
  updateCity as updateCityGraphQL,
  creatCitySpySettings as creatCitySpySettingsGQL,
  updateCitySpySettings as updateCitySpySettingsGQL,
} from './../../../../../../Module/graphQL'
import { authorization } from './../../../../../../Module/Auth/Auth'
import View from './View'
import { validateCityDataPayload } from '../../util/validators'
import getCitySettingsData from './gql'

import useGraphQLFetch from 'Utils/Hooks/useGraphQLFetch'

const EditCityDetailsController = props => {
  const [isSaving, setIsSaving] = useState(false)
  const [cityData, setCityData] = useState({})

  const response = useGraphQLFetch({
    fetchFn: getCitySettingsData,
    defaultFetchArgs: props.cityId,
    fetchId: 'getCitySettingsData',
  })
  useEffect(() => {
    if (response.isLoaded) {
      const cityInfo = response.data.city
      if (cityInfo) {
        setCityData(cityInfo)
      }
    }
  }, [response.isLoaded])
  const updateCity = async updateData => {
    if (!validateCityDataPayload(updateData)) {
      return
    }
    setIsSaving(true)

    updateData = {
      ...updateData,
      statusV2: updateData.status,
      location: updateData.cityLocation,
    }
    delete updateData.status
    delete updateData.cityLocation
    var response = await updateCityGraphQL(
      authorization.getAPIKey(),
      props.cityId,
      updateData,
    )
    var result = await response.json()

    if (result['errorMessage']) return alert(result['errorMessage'])
    if (result.errors && result.errors[0])
      return alert(new Error(result.errors[0].message))
    setIsSaving(false)
  }

  const updateCitySpySettings = async updateData => {
    setIsSaving(true)

    updateData = {
      ...updateData,
      cityId: props.cityId,
    }

    const isCreating = !cityData.spySettings || !cityData.spySettings.id

    const updateFunc = isCreating
      ? creatCitySpySettingsGQL
      : updateCitySpySettingsGQL

    let newSpyCitySettings
    try {
      const response = await updateFunc(updateData)
      const result = await response.json()
      if (isCreating) {
        newSpyCitySettings =
          result['data'] && result['data']['createSpyCitySettings']
      } else {
        newSpyCitySettings =
          result['data'] && result['data']['updateSpyCitySettings']
      }

      if (result['errorMessage']) return alert(result['errorMessage'])
      if (result.errors && result.errors[0])
        return alert(new Error(result.errors[0].message))

      if (newSpyCitySettings) {
        setCityData({
          ...cityData,
          spySettings: newSpyCitySettings,
        })
      }
    } catch (e) {
      console.error(e)
    } finally {
      setIsSaving(false)
    }
  }

  return response.isLoaded && cityData.name ? (
    <View
      isLoaded={response.isLoaded}
      isSaving={isSaving}
      updateCity={updateCity}
      enableEditCountry={false}
      enableChangeTimezone={false}
      cityData={cityData}
      updateCitySpySettings={updateCitySpySettings}
    />
  ) : null
}

export default EditCityDetailsController



// WEBPACK FOOTER //
// ./src/Containers/Form/City/CityAddEdit/Edit/EditCityDetails/Controller.js